"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributeIdentifiersPlaceholdersFromUrl = exports.joinDrillUrlParts = exports.splitDrillUrlParts = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
function matchAll(regex, text) {
    var matches = [];
    var match = null;
    while ((match = regex.exec(text)) !== null) {
        matches.push(match);
    }
    return matches;
}
var identifierSplitRegexp = /(\{attribute_title\(.*?\)\})/g;
var identifierMatchRegexp = /\{attribute_title\((.*?)\)\}/g;
var identifierToPlaceholder = function (ref) { return "{attribute_title(" + ref.identifier + ")}"; };
var matchToUrlPlaceholder = function (match) { return ({
    placeholder: match[0],
    identifier: match[1],
    ref: sdk_model_1.idRef(match[1], "displayForm"),
    toBeEncoded: match.index !== 0,
}); };
var splitUrl = function (url) { return url.split(identifierSplitRegexp); };
/**
 * @internal
 */
exports.splitDrillUrlParts = function (url) {
    return splitUrl(url).map(function (urlPart) {
        var match = identifierMatchRegexp.exec(urlPart);
        if (match !== null) {
            return matchToUrlPlaceholder(match).ref;
        }
        return urlPart;
    });
};
/**
 * @internal
 */
exports.joinDrillUrlParts = function (parts) {
    // Back compatibility
    if (isString_1.default(parts)) {
        return parts;
    }
    return parts
        .map(function (urlPart) {
        if (sdk_model_1.isIdentifierRef(urlPart)) {
            return identifierToPlaceholder(urlPart);
        }
        return urlPart;
    })
        .join("");
};
/**
 * @internal
 */
exports.getAttributeIdentifiersPlaceholdersFromUrl = function (url) {
    return matchAll(identifierMatchRegexp, url).map(matchToUrlPlaceholder);
};
//# sourceMappingURL=drillUrls.js.map